<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "BnplFeesCalculator" });
import { currency } from "../../../../common/format.js";
import { FEE_RATES } from "./config.js";
export let currencyCode;
export let financeOptionCode;
export let value;
export let fee = 0;
const calculateFees = (value2, rate) => {
    if (value2 <= 0) {
        return 0;
    }
    return Number(value2 / (1 - rate) * rate);
};
const getRate = (financeCode) => {
    if (financeCode === void 0) {
        return 0;
    }
    return FEE_RATES[financeCode];
};
$: fee = calculateFees(value, getRate(financeOptionCode)) || 0;
</script>

{currency(fee ?? 0, currencyCode, false)}